var $46b77281e4caa836$exports = {};
$46b77281e4caa836$exports = {
    "decrease": (args)=>`Zmniejsz ${args.fieldLabel}`,
    "increase": (args)=>`Zwi\u{119}ksz ${args.fieldLabel}`,
    "numberField": `Pole numeru`
};


export {$46b77281e4caa836$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
